import React from 'react';

const ProgressBar = ({ survey, progress }) => {
    if (!survey?.showProgressbar) return null;

    const isSteps = survey.progressbarType === 'STEPS' && typeof progress === 'object';
    const percent = isSteps
        ? Math.round((progress.current / Math.max(progress.total, 1)) * 100)
        : Number(progress) || 0;
    const label = isSteps
        ? `Question ${progress.current} of ${progress.total}`
        : `${percent}% complete`;

    return (
        <div className="ecx-survey-preview__progress">
            <div className="ecx-survey-preview__progress-meta">
                <span>Progress</span>
                <span>{label}</span>
            </div>
            <div className="progress ecx-survey-preview__progress-bar" role="progressbar">
                <div
                    className="progress-bar"
                    style={{ width: `${Math.min(Math.max(percent, 0), 100)}%` }}
                />
            </div>
        </div>
    );
};

export default ProgressBar;
